(() => {
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) document.dispatchEvent(new Event('oniPrivacyReady'));
    });
  }
  if (window.oniMeasurementLoaded) return;
  window.oniMeasurementLoaded = true;
  const sections = ['hero-title', 'coupon', 'newsletter', 'gift', 'products', 'faq'];
  const seen = new Set();
  let lastSection = 'top';
  let maxScroll = 0;
  let lastAction = 'page_view';
  function publish(stage, detail = {}) {
    lastAction = stage;
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || !privacy.analyticsProcessingAllowed()) return;
    window.Shopify?.analytics?.publish('oni:funnel', {
      stage, page_path: location.pathname, section: lastSection,
      scroll_percent: maxScroll, ...detail
    });
  }
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting || entry.target.getClientRects().length === 0) continue;
      lastSection = entry.target.id;
      if (!seen.has(lastSection)) {
        seen.add(lastSection);
        publish('section_view');
      }
    }
  }, { rootMargin: '-10% 0px -40% 0px', threshold: 0 });
  sections.forEach(id => { const el = document.getElementById(id); if (el) observer.observe(el); });
  window.addEventListener('scroll', () => {
    const height = document.documentElement.scrollHeight - innerHeight;
    const percent = height > 0 ? Math.min(100, Math.round(scrollY / height * 100)) : 100;
    maxScroll = Math.max(maxScroll, percent);
    for (const level of [25, 50, 75, 90]) {
      if (percent >= level && !seen.has(level)) {
        seen.add(level);
        publish('scroll_depth', { scroll_percent: level });
      }
    }
  }, { passive: true });
  const form = document.getElementById('oni-newsletter-form');
  form?.addEventListener('focusin', () => {
    if (!seen.has('signup_start')) { seen.add('signup_start'); publish('signup_start'); }
  });
  form?.addEventListener('invalid', () => publish('signup_validation_error'), true);
  form?.addEventListener('submit', () => {
    try { sessionStorage.setItem('oni_signup_pending', '1'); } catch (_) {}
    publish('signup_submit');
  });
  function privacyReady() {
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) return;
    sections.forEach(id => {
      const el = document.getElementById(id);
      if (el) { seen.delete(id); observer.unobserve(el); observer.observe(el); }
    });
    try {
      if (form?.querySelector('[role="status"]') && sessionStorage.getItem('oni_signup_pending')) {
        sessionStorage.removeItem('oni_signup_pending');
        publish('signup_received');
      }
    } catch (_) {}
  }
  document.addEventListener('oniPrivacyReady', privacyReady);
  document.addEventListener('visitorConsentCollected', privacyReady);
  privacyReady();
  document.addEventListener('click', event => {
    const el = event.target.closest('a,button');
    if (!el) return;
    if (el.matches('[data-copy-code]')) publish('coupon_copy_click');
    if (el.id === 'catalog-more') publish('catalog_more');
    if (el.tagName === 'A') {
      const url = new URL(el.href, location.href);
      if (url.origin === location.origin && /^\/(products|collections|cart|checkouts)(\/|$)/.test(url.pathname)) {
        publish('navigation_click', { destination: url.pathname });
      }
    }
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') publish('page_hidden', { last_action: lastAction });
  });
})();
